import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LandingFooter.css';

const LandingFooter = () => {
    const { t } = useTranslation(['navigation', 'common', 'landing']);

    return (
        <footer className="landing-footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <div className="logo">SkillTherapy AI</div>
                        <p>{t('landing:hero.subtext', 'Personalized Learning for Every Student')}</p>
                    </div>
                    <div className="footer-links">
                        <h4>{t('landing:footer.quickLinks', 'Quick Links')}</h4>
                        <ul>
                            <li><Link to="/about">{t('landing:footer.about', 'About Us')}</Link></li>
                            <li><Link to="/privacy">{t('landing:footer.privacy', 'Privacy Policy')}</Link></li>
                            <li><Link to="/terms">{t('landing:footer.terms', 'Terms of Service')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-links">
                        <h4>{t('landing:footer.support', 'Support')}</h4>
                        <ul>
                            <li><Link to="/contact">{t('landing:footer.contact', 'Contact Us')}</Link></li>
                            <li><Link to="/help">{t('landing:footer.help', 'Help Center')}</Link></li>
                            <li><Link to="/faq">{t('landing:footer.faq', 'FAQ')}</Link></li>
                        </ul>
                    </div>
                    <div className="footer-brand">
                        <h4>{t('common:legal', 'Legal')}</h4>
                        <p>&copy; 2026 SkillTherapy AI. {t('landing:footer.copyright', 'All rights reserved.')}</p>
                        <p><strong>{t('landing:footer.legalEntity', 'Legal Entity: PRIYANKA SINGH')}</strong></p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default LandingFooter;
